import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import icons from "../../../assets/images/constantIcons";

const PlayerPopup = ({ isOpen, onClose, onPlayerSuccess }) => {
  const [parties, setParties] = useState([]);

  useEffect(() => {
    if (isOpen) {
      fetchParties();
    }
  }, [isOpen]);

  const fetchParties = async () => {
    try {
      const response = await apiService.get("/parties");
      setParties(response.data || []);
    } catch (errors) {
      handleError(errors);
    }
  };

  const formik = useFormik({
    initialValues: {
      party: "",
    },
    validationSchema: Yup.object({
      party: Yup.string()
        .matches(/^[A-Za-z\s]+$/, "Only alphabets and spaces allowed")
        .required("Party name is required"),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const existingNames = parties.map((item) =>
        item.name.toLowerCase().trim()
      );
      const newName = values.party.trim().toLowerCase();

      if (existingNames.includes(newName)) {
        toast.error("This party name already exists!", { duration: 1000 });
        setSubmitting(false);
        return;
      }

      try {
        const payload = {
          party: {
            name: values.party,
          },
        };

        const response = await apiService.post("/parties", payload);
        toast.success(response.message || "Party added successfully!", {
          duration: 2000,
        });
        onPlayerSuccess(values.party);
        resetForm();
        onClose();
      } catch (errors) {
        handleError(errors);
      } finally {
        setSubmitting(false);
      }
    },
  });

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-6 w-[320px] relative">
        <h3 className="text-xl font-semibold mb-7 text-G500 text-start">
          Add Party
        </h3>
        <div
          className="absolute top-5 right-3 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px] flex justify-center items-center"
          onClick={() => {
            formik.resetForm();
            onClose();
          }}
        >
          <icons.IoClose className="text-green700 text-xl" />
        </div>
        <form onSubmit={formik.handleSubmit} className="space-y-4">
          <div className="relative text-G300">
            <label className="text-sm font-medium text-G500 mb-2 block">Party Name <span className="text-red ">*</span></label>
            <input
              type="text"
              name="party"
              autoComplete="off"
              className="inputtext relative"
              placeholder="Enter party name"
              value={formik.values.party}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.party && formik.errors.party && (
              <div className="text-red text-sm pt-1">{formik.errors.party}</div>
            )}
          </div>

          <div className="flex justify-end space-x-4 pt-8">
            <button
              type="button"
              className="w-[75px] sm:w-[93px] py-2 text-center text-sm bg-white text-green rounded-lg border border-green"
              onClick={() => {
                formik.resetForm();
                onClose();
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={formik.isSubmitting}
              className="w-[75px] sm:w-[93px] text-sm text-center py-2 rounded-lg bg-green text-white"
            >
              {formik.isSubmitting ? "Submiting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PlayerPopup;
